import { createContext, useContext } from 'react';

export const MenuScrollListenerContext = createContext({});

export const useMenuScrollListener = () => useContext<any>(MenuScrollListenerContext);
